import ./lib/extensions.civet
import ./system-shiv.civet

{ Dexie } from dexie
window.Dexie = Dexie

{ Login, Modal } from @danielx/dui

{ DEFAULT_SPRITE_SHA } from ./const.civet
{ checkUnlock, takeUnlockToken } from ./lib/unlock.civet
{ showNotice, PUBLISH_FIX_NOTICE } from ./lib/notice.civet

Player from ./player.civet
Song from ./song-v2.civet
ButtonTemplate from ./templates/button
TestSongs from ./dev/test-songs.civet

// Before the player exists: its persistence reads the hash as a song slug
unlockToken := takeUnlockToken()

player := new Player()
global.player = player

document.body.append player.element

showNotice PUBLISH_FIX_NOTICE

// Init with default settings
//@ts-expect-error
player.song.init Song().toMidi()
player.song.synthSha "ujwLwBnzFSVrrjlCVJ2KvVJxO-n6YahfEQ82ikcFSjw"
player.song.spriteSha DEFAULT_SPRITE_SHA
player.trigger "reset"
player.pushState player.getState()

// LOCAL-ONLY: a test collection of pieces with practice metadata baked in,
// for exercising the practice/game/lesson mechanics (F4 or testSongs()).
// Available on the dev server and in an unpackaged Electron run (`npm
// start` in app/, which loads the symlinked composer/www bundle); a
// packaged/Steam build never gets it.
devBuild := do
  if ["localhost", "127.0.0.1"].includes location.hostname
    true
  else if global.ELECTRON_VERSION
    try
      !global.require("@electron/remote").app.isPackaged
if devBuild
  TestSongs player

  // Electron has no menu bar here (autoHideMenuBar + fullscreen), so bind the
  // usual key ourselves. Packaged builds never reach this branch.
  if global.ELECTRON_VERSION
    player.addHotkey "f12", (->
      global.require("@electron/remote").getCurrentWindow().webContents.toggleDevTools()
    ),
      category: "Dev"
      name: "Toggle DevTools"

// TODO: Dev
// player.purchased true

// player.virtualKeyboard()

// Suppress right-click context menu globally — the canvas uses right-click for erase.
// Chrome retargets the contextmenu event to BODY for canvas right-clicks, so we
// listen on document and prevent unconditionally.
document.addEventListener "contextmenu", (e: Event) -> e.preventDefault()

// Service Worker
// TODO: this probably needs to be added to the HTML prometheus publishes
// try
//   // Can't register in blob urls or other places where there is no host
//   // Don't register in Electron
//   if location.host and !global.ELECTRON_VERSION
//     navigator.serviceWorker.register('./sw.js')
// catch e
//   console.warn e.message

// A direct purchase's emailed link unlocks the web version (lib/unlock.civet)
unless global.ELECTRON_VERSION
  // After the startup soundfont load: its loading modal would replace an earlier alert
  alertAfterStartup := (message: string) ->
    done := -> Modal.alert message
    player.audioReady.then done, done

  checkUnlock(unlockToken).then (result) ->
    switch result
      when "new", "stored"
        player.purchased true
        if result is "new"
          alertAfterStartup "Paint Composer is unlocked in this browser. Thanks for your purchase!"
      when "invalid"
        alertAfterStartup "That unlock link didn't check out. Reply to your purchase email and I'll send a fresh one."

// Display purchase prompt every 15 minutes on free version
setInterval ->
  // Don't display over an existing modal
  unless player.purchased() or Modal.visible()
    player.purchase()
, 1000 * 60 * 15

// Electron App Exit Button and purchased state
if global.ELECTRON_VERSION
  remote := global.require("@electron/remote")

  // Privacy Policy / Terms are web-only; drop them from the packaged About page.
  player.aboutTemplate.querySelectorAll('[rel="privacy-policy"], [rel="terms-of-service"]').forEach (el) ->
    el.remove()

  // Set purchased state
  player.purchased(true)

  // Override beforeUnload for the electron world
  player.removeUnloadHandler()
  closing .= false
  window.addEventListener "beforeunload", (e) ->
    if closing
      return

    player.confirmUnsaved()
    .then ->
      closing = true
      // remote.getCurrentWindow().close()
      window.close()

    return e.returnValue = true

  player.element.querySelector('section.buttons')!.appendChild ButtonTemplate
    text: "🚪 Exit"
    class: "exit"
    click: ->
      window.close()

  // Override toggle fullscreen to work in electron
  player.fullscreen = ->
    w := remote.getCurrentWindow()
    w.setFullScreen(!w.isFullScreen())

// TODO: Use latest system apis
// Whimsy.Space shared login


cognitoConfig :=
  identityPoolId: 'us-east-1:4fe22da5-bb5e-4a78-a260-74ae0a140bf9'
  poolData:
    UserPoolId : 'us-east-1_cfvrlBLXG'
    ClientId : '3fd84r6idec9iork4e9l43mp61'
|> as const

window.cognitoConfig = cognitoConfig

new Promise (resolve, reject) ->
  Login {
    cognito: cognitoConfig
    headless: true
    resolve
    reject
  }
.then player.account
